import { IconButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import Iconify from 'src/components/iconify';
import MenuPopover from 'src/components/menu-popover';
import ModeOptions from 'src/components/settings/drawer/ModeOptions';
import { useLocales } from 'src/locales';

export const ToggleTheme = () => {
  const { translate } = useLocales();
  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const theme = useTheme();

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <Tooltip
        placement="bottom"
        arrow
        title={translate('shared.labels.change_theme')}
      >
        <IconButton
          color="inherit"
          onClick={handleOpenPopover}
          sx={{
            width: 36,
            height: 36,
            borderRadius: 1,
            ...(openPopover && {
              backgroundColor: theme.palette.action.selected,
            }),
          }}
        >
          <Iconify icon="tabler:contrast-filled" />
        </IconButton>
      </Tooltip>

      <MenuPopover
        open={openPopover}
        onClose={handleClosePopover}
        sx={{ mt: 1.5 }}
        arrow="top-center"
      >
        <ModeOptions size="small" />
      </MenuPopover>
    </>
  );
};
